import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContractDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    viewBox="0 0 13 14"
    {...props}
  >
    <path
      fill="red"
      d="m10.798 11.85-.85.85a.55.55 0 0 1-.416.175.6.6 0 0 1-.417-.192.583.583 0 0 1 0-.85L9.948 11l-.85-.85a.55.55 0 0 1-.175-.425.62.62 0 0 1 .192-.425.583.583 0 0 1 .85 0l.833.85.85-.85a.583.583 0 0 1 .85 0 .583.583 0 0 1 0 .85l-.85.85.85.85a.57.57 0 0 1 .184.416.57.57 0 0 1-.184.417.583.583 0 0 1-.85 0zm-8.8 1.55q-.666 0-1.133-.467A1.54 1.54 0 0 1 .398 11.8v-1.2q0-.495.353-.848.352-.352.847-.352h.4V1.8q0-.495.353-.848Q2.703.6 3.198.6h7.2q.495 0 .848.352.352.353.352.848v5.283a3.7 3.7 0 0 0-1.2-.067V1.8h-7.2v7.6h3.95a3 3 0 0 0-.208.583q-.075.3-.108.617H1.598v1.2q0 .17.115.285a.39.39 0 0 0 .285.115h5q.1.333.259.633.158.3.358.567zm5.05-1.2h-5.45 5.234-.017zM4.598 5a.58.58 0 0 1-.427-.172.57.57 0 0 1-.173-.425q0-.254.173-.428a.58.58 0 0 1 .427-.175h4.4q.255 0 .428.171a.57.57 0 0 1 .172.425.59.59 0 0 1-.172.429.58.58 0 0 1-.428.175zm0 2a.58.58 0 0 1-.427-.172.57.57 0 0 1-.173-.425q0-.254.173-.428a.58.58 0 0 1 .427-.175h4.4q.255 0 .428.171a.57.57 0 0 1 .172.425.59.59 0 0 1-.172.429.58.58 0 0 1-.428.175z"
    />
  </svg>
);
export default SvgContractDelete;
